import React, { Fragment, useState } from 'react';

const PasswordReset = ({ id_space }) => {

    const [new_password, setNew_password] = useState("")
    const [new_password2, setNew_password2] = useState("")
    const [failed, setFailed] = useState(false)
    const [incomplete, setIncomplete] = useState(false)
    const [completed, setCompleted] = useState(false)

    function reset() {
        setNew_password("")
        setNew_password2("")
        setIncomplete(false);
        setFailed(false)
        setCompleted(false)
    }


    const onSubmitForm = async (e) => {
        e.preventDefault();

        try {
            if (new_password.localeCompare(new_password2) !== 0) {
                setFailed(true)
                setCompleted(false)
                throw new Error('Password doesn\'t match')
            }
            setFailed(false);
            if (/\d/.test(new_password) == false || new_password.length < 6 || /[a-zA-Z]/.test(new_password) == false || /\W/.test(new_password) == false) {
                setIncomplete(true);
                setCompleted(false);
                throw new Error('Bad Password')
            }
            setIncomplete(false);
            const body = { new_password }
            const response = await fetch("/auth/reset_password", {
                method: "PUT",
                headers: { "Content-Type": "application/json", token: localStorage.token },
                body: JSON.stringify(body)
            }).then(function (response) {
                if (response.status >= 400) {
                    console.log('sss')
                    setFailed(true);
                    setIncomplete(true);
                    setCompleted(false);
                    throw new Error('Bad Password')
                } else if (response.status == 200) {
                    setCompleted(true)
                    setNew_password("");
                    setNew_password2("");
                }
            })
        } catch (err) {
            console.error("Cannot reset password (server side)")
            console.error(err.message);
        }
    }


    return (
        <Fragment>
            <button type="button" className="btn btn-block btn-warning" data-toggle="modal" data-target={`#idReset${id_space}`} style={{ padding: "10px 22px" }}>
                Change Password
            </button>

            <div className="modal fade" id={`idReset${id_space}`}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Change Password</h4>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => reset()}>&times;</button>
                        </div>

                        <form className="mt-5 text-center" onSubmit={onSubmitForm}>
                            <div className="modal-body">
                                <input placeholder="Password" type="password" className="form-control" value={new_password} onChange={e => setNew_password(e.target.value)} />
                                <input placeholder="Password" type="password" className="form-control" value={new_password2} onChange={e => setNew_password2(e.target.value)} />
                                {failed && <h6 className="text-danger">Passwords don't match</h6>}
                                {incomplete && <h6 className="text-danger">Passwords must contain at least one number, letter, and symbol.</h6>}
                                {incomplete && <h6 className="text-danger">It must also be 6 characters or more in length.</h6>}
                                {completed && <h6 className="text-success">Password Changed!</h6>}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" onClick={onSubmitForm} >Submit</button>
                                <button type="button" className="btn btn-info" data-dismiss="modal" onClick={() => reset()}>Close</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default PasswordReset;